// extracted by mini-css-extract-plugin
export default {"container":"styles_container__B4ZZy","form":"styles_form__lso1s","bottomContainer":"styles_bottomContainer__eErXp"};